/**
 * Constantes del módulo de Observaciones.
 * IDs corresponden a control.TAB_STATUSES grupo 'observations'.
 */

// ─── Status IDs (grupo: observations en TAB_STATUSES) ───────────
export const OBSERVATION_STATUS = {
  OPEN: 23,
  CLOSED: 24,
  DELETED: 25,
};

// ─── Status options para Select/Dropdown ────────────────────────
export const OBSERVATION_STATUS_OPTIONS = [
  { id: OBSERVATION_STATUS.OPEN, key: "open", label: "Open" },
  { id: OBSERVATION_STATUS.CLOSED, key: "closed", label: "Closed" },
];

// ─── Colores de status para badges/chips ────────────────────────
export const OBSERVATION_STATUS_COLORS = {
  [OBSERVATION_STATUS.OPEN]: "green",
  [OBSERVATION_STATUS.CLOSED]: "gray",
  [OBSERVATION_STATUS.DELETED]: "red",
};
